module.exports = __webpack_public_path__ + "img/rose-petal.b1a74824.png";